import React, { useContext } from "react"
import styled from "styled-components"
import { FilterContext } from "../../providers/FilterProvider"
import { device } from "../../theme"

const StyledUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-top: 22px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
`

const StyledLi = styled.li`
  color: #444;
  font-size: 0.9rem;
  cursor: pointer;
  margin-left: 12px;
  transition: transform 0.1s ease-in-out;

  @media ${device.phone} {
    font-size: 1rem;
  }

  &:hover {
    font-weight: bold;
    transform: translateX(4px);
  }

  &.selected-price {
    color: ${props => props.theme.colors.green};
    font-weight: bold;
    transform: translateX(4px);
  }
`

function SortPrices({ category, gender, active, setActive }) {
  const { state, dispatch } = useContext(FilterContext)
  const handleSort = async type => {
    if (type === active) return
    setActive(type)

    let url = `https://static8-api.herokuapp.com/lineout/feed?gender=${
      gender === "herre" ? "male" : "female"
    }&sortBy=${type}&size=20&page=0&category=${category}`

    if (state.selectedBrands.length) {
      const encodeBrands = encodeURIComponent(
        JSON.stringify(state.selectedBrands)
      )
      const activeGender = gender === "herre" ? "men" : "women"
      url = `https://static8-api.herokuapp.com/lineout/search?gender=${activeGender}&sortBy=${type}&size=20&page=0&category=${category}&brands=${encodeBrands}`
    }

    await fetch(url)
      .then(res => res.json())
      .then(e => dispatch({ products: e, sortBy: type }))
      .catch(err => console.log("err", err))

    document.body.scrollTop = 0
  }

  return (
    <StyledUl>
      <StyledLi
        onClick={() => handleSort("relevans")}
        className={active === "relevans" ? "selected-price" : ""}
      >
        Relevans
      </StyledLi>
      <StyledLi
        onClick={() => handleSort("lowest")}
        className={active === "lowest" ? "selected-price" : ""}
      >
        Laveste pris
      </StyledLi>
      <StyledLi
        onClick={() => handleSort("highest")}
        className={active === "highest" ? "selected-price" : ""}
      >
        Højeste pris
      </StyledLi>
    </StyledUl>
  )
}

export default SortPrices
